module.exports = __webpack_public_path__ + "static/media/image-no-booking.a2a340e3.png";